import Action, {PUT} from "../common/Action";

export const editStoreAction = new Action('EDIT_STORE', PUT, (params) => `Store/update`) ;

export const editStore = (data) => editStoreAction.callApi(data);